import $ from 'jquery';

let directive = function($window, $timeout, $rootScope) {
	'ngInject'
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			var key = attrs.sameHeight;
			var timeout = attrs.timeout;

			scope.$on('PROCESS_DONE', function() {
				$('.auto-resized').removeClass('auto-resized');
				getHighest();
			});

			function getHighest() {
				if (!angular.element(element).hasClass('auto-resized')) {
					var maxHeight = 0;
					var $elements = $('*[same-height=' + key + ']');
					$elements.css('height', 'auto');
					if ($elements.length > 2) {
						$elements.each(function() {
							if (this.offsetHeight > maxHeight) {
								maxHeight = this.offsetHeight;   
							}
						});
						$elements.height(maxHeight).addClass('auto-resized');
					}
				}
			}
			if (timeout) {
				$timeout(getHighest, timeout/2);
			} else {
				getHighest();
			}
			

			angular.element($window).bind('resize', function() {
				$('.auto-resized').removeClass('auto-resized');
				getHighest();
			});
			
		}
	};
}

export default directive;


// WEBPACK FOOTER //
// ./app/shared/directives/sameHeight.directive.js